
import {
  HttpInterceptorFn
} from '@angular/common/http';

export const jwtInterceptor:
HttpInterceptorFn = (
  req,
  next
) => {

  console.log('INTERCEPTOR EXECUTOU');

  const token =
    localStorage.getItem('token');

  console.log('TOKEN:', token);

  if (token) {

    req = req.clone({

      setHeaders: {

        Authorization:
          `Bearer ${token}`

      }

    });

    console.log(
      'HEADER:',
      req.headers.get('Authorization')
    );

  }

  return next(req);

};

// export const jwtInterceptor: HttpInterceptorFn = (
//   req,
//   next
// ) => {

//   const token =
//     localStorage.getItem('token');

//   console.log('TOKEN:', token);

//   if (token) {

//     req = req.clone({

//       setHeaders: {

//         Authorization:
//           `Bearer ${token}`
//       }
//     });

//   }

//   console.log(
//     'URL:',
//     req.url
//   );

//   console.log(
//     'AUTH:',
//     req.headers.get('Authorization')
//   );

//   return next(req);
// };


// export const jwtInterceptor:
// HttpInterceptorFn = (
//   req,
//   next
// ) => {

//   const token =
//     localStorage.getItem('token');

//   if (token) {

//     req = req.clone({

//       setHeaders: {

//         Authorization:
//           `Bearer ${token}`
//       }
//     });
//   }

//   return next(req);
// };